<div class="standard-page-layout" [class.is-menu]="isMainSection">
  <aside>
    <h1>
      <a class="main-link" routerLink="/settings">
        <mat-icon>settings</mat-icon>
        Settings
      </a>
    </h1>

    <ng-template #settingsLink let-section="section" let-parentSection="parentSection">
      @if (section.externalUrl) {
        @if (section.openInNewTab) {
          <a mat-button target="_blank" [href]="section.externalUrl">
            <span [innerHTML]="section.icon | trustHtml"></span>
            {{section.label}}
          </a>
        }
        @if (!section.openInNewTab) {
          <a mat-button [href]="section.externalUrl">
            <span [innerHTML]="section.icon | trustHtml"></span>
            {{section.label}}
          </a>
        }
      }
      @if (!section.externalUrl && section.action) {
        <a mat-button href="javascript:;" (click)="section.action($event)">
          <span [innerHTML]="section.icon | trustHtml"></span>
          {{section.label}}
        </a>
      }
      @if (!section.externalUrl && !section.action) {
        @if (section.defaultSubPage) {
          <a
            mat-button
            routerLink="/settings/{{parentSection ? parentSection.id + '/' : ''}}{{section.id}}/{{section.defaultSubPage}}">
            <span [innerHTML]="section.icon | trustHtml"></span>
            {{section.label}}
          </a>
        }
        @if (!section.defaultSubPage) {
          <a mat-button routerLink="/settings/{{parentSection ? parentSection.id + '/' : ''}}{{section.id}}">
            <span [innerHTML]="section.icon | trustHtml"></span>
            {{section.label}}
          </a>
        }
      }
    </ng-template>

    <ul>
      @for (section of sections; track section) {
        @if (shouldShowSection(section)) {
          <li [class.active]="mainSectionId === section.id">
            <ng-container *ngTemplateOutlet="settingsLink; context: {section:section}"></ng-container>
            @if (section.subpages && section.subpages.length > 0) {
              <ul>
                @for (subpage of section.subpages; track subpage) {
                  @if (!subpage.hidden || secondarySectionId === subpage.id) {
                    <li
                      [class.active]="secondarySectionId === subpage.id">
                      <ng-container *ngTemplateOutlet="settingsLink; context: {section:subpage, parentSection: section}">
                      </ng-container>
                    </li>
                  }
                }
              </ul>
            }
          </li>
        }
      }
    </ul>
  </aside>
  <div class="page">
    <h2>
      <span class="mobile-breadcrumb">
        <a routerLink="/settings">
          <mat-icon>settings</mat-icon>
          Settings
        </a>
        &raquo;
      </span>
      @if (section) {
        {{section.label}}
      }
      @if (secondarySection) {
        &raquo; {{secondarySection.label}}
      }
    </h2>

    @if (!sectionReady) {
      <app-spinner></app-spinner>
    } @else {
      @if (sectionId === 'account/change-username') {
        <tyt-change-username
          (canceled)="goTo('/settings/account')"
        (usernameSet)="goTo('/settings/account')"></tyt-change-username>
      }
      @if (sectionId === 'account/change-email') {
        <tyt-change-email
          (canceled)="goTo('/settings/account')"
        (emailChanged)="goTo('/settings/account')"></tyt-change-email>
      }
      @if (sectionId === 'account/change-password') {
        <tyt-change-password
          (canceled)="goTo('/settings/account')"
          (passwordChanged)="goTo('/settings/account')"></tyt-change-password>
      }
      @if (sectionId === 'account') {
        <tyt-account-settings></tyt-account-settings>
      }
      @if (sectionId === 'memberships') {
        <tyt-membership-accounts></tyt-membership-accounts>
      }
      @if (sectionId === 'notifications') {
        <tyt-notifications-settings></tyt-notifications-settings>
      }
      @if (sectionId === 'newsletters') {
        <app-communication-preference></app-communication-preference>
      }
      @if (sectionId === 'messaging') {
        <mat-tab-group mat-stretch-tabs="false">
          <mat-tab label="Email">
            <h2>Newsletters</h2>
            <app-communication-preference></app-communication-preference>
          </mat-tab>
          <mat-tab label="Notifications">
            <tyt-notifications-settings></tyt-notifications-settings>
          </mat-tab>
          @if (isTextingSupported) {
            <mat-tab label="Texting">
              <h2>Text Alerts from TYT</h2>
              <tyt-texting-optin [enableMask]="false" />
            </mat-tab>
          }
        </mat-tab-group>
      }
      @if (sectionId === 'content') {
        @if (!onboarding || !user) {
          <div>
            Follow topics, shows, hosts, and politicians you are interested in
            to customizing your experience on TYT.com
          </div>
          <br/>
          <a mat-raised-button color="primary" routerLink="/settings/content/topics">
            <mat-icon>edit</mat-icon>
            Change Follows
          </a>
        }
        @if (onboarding && user) {
          <div>
            Personalize your experience by following topics, hosts, shows
            and politicians!
          </div>
          <br/>
          <a mat-raised-button color="primary" routerLink="/settings/content/topics">
            <mat-icon>rocket</mat-icon>
            Get Started
          </a>
        }
      }
      @if (sectionId === 'content/topics') {
        @if (!isOnline) {
          <tyt-offline message="You need an Internet connection to update your followed shows."></tyt-offline>
        }
        @if (isOnline) {
          @if (onboarding && user) {
            <div class="alert alert-info with-icon">
              <mat-icon>info</mat-icon>
              <div>
                Select what interests you most, and you'll see favorites on all TYT platforms when logged in.
              </div>
            </div>
          }
          @if (savingTopics) {
            <app-spinner></app-spinner>
          } @else {
            <tyt-topic-selector [availableTopics]="categoryTopics" [(followedTopics)]="followedCategoryTopics">
            </tyt-topic-selector>
            <div class="submit-step">
              <button type="button" (click)="saveCategoryTopics()" mat-raised-button color="primary">Save &amp; Take Me to Shows</button>
            </div>
          }
        }
      }
      @if (sectionId === 'content/done') {
        <div class="alert alert-success with-icon">
          <mat-icon>check_box</mat-icon>
          <div>
            <strong>Your content feed settings are now saved</strong>
            <p>
              You may add or remove favorites at any time. Selected content will be shown on all
              devices you are logged into.
            </p>
            <a routerLink="/home" mat-raised-button color="primary">Back to TYT</a>
            <a routerLink="/settings/content/topics" mat-button>Redo</a>
          </div>
        </div>
      }
      @if (sectionId === 'privacy-controls') {
        <tyt-privacy-controls></tyt-privacy-controls>
      }
      @if (sectionId === 'one-time-contribution') {
        @if (isOnline) {
          <iframe #accountsIframe class="accounts-subframe" [src]="oneTimeContributionUrl"></iframe>
        }
        @if (!isOnline) {
          <tyt-offline message="An Internet connection is required to send a donation."></tyt-offline>
        }
      }
      @if (sectionId === 'content/shows') {
        @if (!isOnline) {
          <tyt-offline message="You need an Internet connection to update your followed shows."></tyt-offline>
        }
        @if (isOnline) {
          @if (savingTopics) {
            <app-spinner></app-spinner>
          }
          @if (!savingTopics) {
            <tyt-topic-selector [availableTopics]="showTopics" [(followedTopics)]="followedShowTopics">
            </tyt-topic-selector>
            <div class="submit-step">
              <button type="button"
                mat-raised-button color="primary"
                [disabled]="!showTopics" (click)="saveShowTopics()"
                >Save &amp; Take Me to
              Hosts</button>
            </div>
          }
        }
      }
      @if (sectionId === 'content/hosts') {
        @if (!isOnline) {
          <tyt-offline message="You need an Internet connection to update your followed shows."></tyt-offline>
        }
        @if (isOnline) {
          @if (savingTopics) {
            <app-spinner></app-spinner>
          }
          @if (!savingTopics) {
            <tyt-topic-selector [availableTopics]="hostTopics" [(followedTopics)]="followedHostTopics">
            </tyt-topic-selector>
            <div class="submit-step">
              <button
                type="button" mat-raised-button color="primary"
                [disabled]="!topics"
                (click)="saveHostTopics()"
                >Save Preferences &amp;
              Finish</button>
            </div>
          }
        }
      }
      @if (sectionId === 'content/politicians') {
        @if (!isOnline) {
          <tyt-offline message="You need an Internet connection to update your followed shows."></tyt-offline>
        }
        @if (isOnline) {
          @if (savingTopics) {
            <app-spinner></app-spinner>
          } @else {
            <tyt-topic-selector [availableTopics]="politicianTopics" [(followedTopics)]="followedPoliticianTopics">
            </tyt-topic-selector>
            <div class="submit-step">
              <button
                mat-raised-button color="primary"
                type="button" [disabled]="!topics"
                (click)="savePoliticianTopics()"
                >Save Preferences
              &amp; Finish</button>
            </div>
          }
        }
      }
      @if (sectionId === 'help') {
        <div class="help-options">
          <a mat-raised-button color="primary" href="https://help.tyt.com/" target="_blank">
            Visit the Help Center
          </a>
          <a mat-raised-button routerLink="/settings/help/info">
            Account &amp; App Information
          </a>
          <a mat-raised-button routerLink="/settings/help/email">
            Send us an email
          </a>
        </div>
      }
      @if (sectionId === 'help/info') {
        <p>This information can be conveyed to our support team to help us zero in on issues with your
          account, membership, or in-app purchase. This information is included automatically when you
          <a routerLink="/settings/help/email">Send us an email</a>, but if you can't use that feature
          or prefer not to, including this information with your support request can help us resolve your
          problem faster.
        </p>
        <div>
          <button mat-raised-button color="primary" (click)="copyAccountInfoToClipboard()">Copy to Clipboard</button>
        </div>
        @for (section of infoSections; track section) {
          <h3>{{section.label}}</h3>
          @for (item of section.items; track item) {
            <div class="property long">
              <label>{{ item.label }}</label>
              {{ item.value }}
            </div>
          }
        }
      }
      @if (sectionId === 'help/email') {
        <noscript>
          @if (!onClientSide) {
            <div class="warning-statement">
              <h3>
                <mat-icon>warning</mat-icon>
                Javascript required
              </h3>
              <p>To prevent abuse, we need you to enable Javascript in order to send an email directly from TYT.com.
                Otherwise, you can craft your own email and send it to support&#64;tytnetwork.com, but it won't automatically
                include some important technical information that can help us solve problems. Consider navigating to Get
                Help -> Account & App Information and including that information in your email if you wish to avoid enabling
              Javascript.</p>
            </div>
          }
        </noscript>
        @if (onClientSide) {
          <form class="support-email" (submit)="sendEmail()">
            <p>If you can't find a solution in the <a href="https://help.tyt.com/">Help Center</a>, you can reach out to
            our support team. We can help you with app problems, your membership, or any other TYT service. We're generally
          available during business hours in US Pacific time.</p>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Subject</mat-label>
            <input type="text" matInput name="supportEmailTitle" [(ngModel)]="supportEmailTitle" placeholder="I'm having trouble with...">
            <mat-hint>A short description of the issue</mat-hint>
          </mat-form-field>
          <br/>
          <br/>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Describe your problem</mat-label>
            <textarea placeholder="It all started when..." matInput name="problemDescription" [(ngModel)]="problemDescription" style="min-height: 8em;"></textarea>
            <mat-hint>The more detail the better!</mat-hint>
          </mat-form-field>
          <br/>
          <br/>
          <div class="info-statement">
            <mat-icon>done</mat-icon>
            Email will automatically include technical details to help us resolve your issue. You'll be able to review
            this information before sending the email.
          </div>
          <div style="text-align: right;">
            <button type="button" mat-button [disabled]="!supportEmailValid" (click)="copySupportEmail()">Copy to Clipboard</button>
            <button mat-raised-button color="primary" [disabled]="!supportEmailValid">Review &amp; Send</button>
          </div>
          <h3>Having trouble?</h3>
          <p>If your mail client isn't opening, you can <a href="javascript:;" (click)="copySupportEmail()">click here</a> to copy the email
          to your clipboard. You'll want to send the email to <strong>support&#64;tytnetwork.com</strong>.</p>
        </form>
      }
    }
    @if (sectionId === 'content/candidates') {
      @if (savingTopics) {
        <app-spinner></app-spinner>
      }
      @if (!savingTopics) {
        <tyt-topic-selector [availableTopics]="candidateTopics" [(followedTopics)]="followedCandidateTopics">
        </tyt-topic-selector>
        <div class="submit-step">
          <button
            mat-raised-button color="primary"
            type="button" [disabled]="!topics" (click)="saveCandidateTopics()"
            >Save Preferences
          &amp; Finish</button>
        </div>
      }
    }
    @if (sectionId === 'faq') {
      This is the Membership FAQ page
    }
  }
</div>
</div>
